import React from 'react';
import PropTypes from 'prop-types';
// elements
import ContextIconMenu from '../Common/ContextIconMenu';
import { ListItem } from 'material-ui/List';
// icons
import AccessGroupIcon from 'material-ui/svg-icons/editor/bubble-chart';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import { statusColours } from '../../constants/ColourConstants';
// constants
import ROLES from '../../constants/Roles';
// business logic
import AccessGroupActions from '../../actions/AccessGroupActionCreator';

const style = {
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};

const getActions = (row) => [
    {
        link: `/dashboard/accessgroup/${row.id}/edit`,
        label: 'Edit',
        icon: <EditIcon />,
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: row.id,
        title: 'Delete Access Group',
        deleteAction: AccessGroupActions.delete,
        message: (
            <span>Are you sure to delete the access group "{row.name}" ?</span>
        ),
        condition: {
            show:  row.sysStatus > 4,
            roles: [ROLES.ADMIN]
        }
    }
];


const AccessGroupListItem = ({data, actions}) => {

        let itemProps = {
            style: style.listItem,
            primaryText: <span>{data.name}</span>,
            leftAvatar: <AccessGroupIcon style={style.icon} color={statusColours.primary} />,
            secondaryTextLines: 2
        };

        const actionList = (actions || getActions(data));

        if (actionList.length > 0) {
            itemProps.rightIcon = <ContextIconMenu actions={actionList} data={data} />;
        }

        if (data.loading) {
            // show loading bar
        } else {
            let description = (data.description || '');
            if (description.length > 50) {
                description = description.substr(0, 45) + '…';
            }
            itemProps.secondaryText = <span>{description}</span>;
        }

        return <ListItem {...itemProps} />

};


AccessGroupListItem.propTypes = {
    data: PropTypes.object.isRequired
};


export default AccessGroupListItem;
